/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Action } from './Action';
import {
    ActionFromJSON,
    ActionFromJSONTyped,
    ActionToJSON,
} from './Action';

/**
 * 
 * @export
 * @interface AddInteractionRequest
 */
export interface AddInteractionRequest {
    /**
     * 
     * @type {Action}
     * @memberof AddInteractionRequest
     */
    action: Action;
}

/**
 * Check if a given object implements the AddInteractionRequest interface.
 */
export function instanceOfAddInteractionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function AddInteractionRequestFromJSON(json: any): AddInteractionRequest {
    return AddInteractionRequestFromJSONTyped(json, false);
}

export function AddInteractionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddInteractionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': ActionFromJSON(json['action']),
    };
}

export function AddInteractionRequestToJSON(value?: AddInteractionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': ActionToJSON(value.action),
    };
}

